import React from 'react';
import { protectedRoute } from '@/modules/core/root/protected/route';
import { createRoute } from '@tanstack/react-router';

export const adminRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'admin',
  wrapInSuspense: true,
  beforeLoad: ({ context }) => {
    if (!context.auth.userIsAdmin()) {
      throw new Error('User is not an admin');
    }
  },
  errorComponent: React.lazy(async () => await import('@/modules/core/pages/not-allowed')),
});
